export const BRISTOL = "https://www.bms.com/latam"
export const GSK="http://ar.gsk.com"
export const JANSSEN ="https://www.janssen.com/argentina/"
export const MSD ="http://www.corporativo.msd.com.ar"
export const TEMIS = "http://www.temislostalo.com.ar"
export const AISICO = "http://www.aisicosrl.com"
export const ANDRE = "https://www.linkedin.com/company/andre-masy-argentina-s.a./?originalSubdomain=ar"
export const ASPEN = "http://www.aspenlatam.com"
export const BIOL = "http://biol.com.ar"
export const DOSA = "http://www.laboratoriodosa.com/index.php/spanish"
export const ECZANE = "http://www.eczane.com.ar/site/"
export const GBT = "http://www.grupobiotoscana.com/default_eni.asp?idioma=1&conta=46"
export const IMVI = "http://www.imvi.com.ar"
export const ISDIN = "https://www.isdin.com/es-AR/"
export const LAB_FIN = "https://www.labfindelmundo.com.ar"
export const PIERRE = "https://www.pierre-fabre.com.ar"
export const TECH = "https://www.linkedin.com/company/ttechsphere-de-argentina-sa/?originalSubdomain=ar"
export const CELNOVA= "https://celnova.com/"
export const LKM = "https://www.linkedin.com/company/laboratorio-lkm-s.a./?originalSubdomain=ar"
export const LUNDBECK = "http://www.lundbeck.com/ar"
export const ORGANON = "https://www.organon.com/latam"
export const FRAMINGHAM = "https://www.framinghampharma.com"
export const SKINTEGRITY = "https://www.skintegrity.com.ar"
export const BIOSINTEX = "https://www.biosintex.com.ar"
export const LUAR = "https://laboratoriosluar.com/"
export const PINTPHARMA = "https://www.pint-pharma.com/portal/es/"
export const PHARMA = "https://www.linkedin.com/company/pharmaim-sa/posts/?feedView=all"
export const DERMADVANCE = "https://www.dermadvance.com.ar/"
export const BIOPAS = "https://www.swixxbiopharma.com/en/biopas/"



// WEBPACK FOOTER //
// ./src/config/urlLabs.js